<div #gridcontainer>
  @if (isColumnOption) {
    <app-data-selector-popup [isColumnOption]="isColumnOption"
      (checkedChangeEvent)="checkChangeColumnsConf($event)" (save)="saveColumnsConf($event)"
    [dataArray]="columnsListFilter" (closeEvent)="closeMenu()" [type]="'window'"></app-data-selector-popup>
  }
  <kendo-grid #grid class="small-text o-pii-kendo-grid" [loading]="pending()" [kendoGridBinding]="groupGridData()"
    [groupable]="false" [navigable]="true" [pageSize]="gridState().take" [skip]="gridState().skip" scrollable="virtual"
    [rowHeight]="rowHeight" [height]="gridHeight()" (pageChange)="pageChange($event)" [sortable]="true"
    [sort]="gridState().sort" [filter]="gridState().filter" [selectable]="{ checkboxOnly: true }"
    [kendoGridSelectBy]="selectedCallback" [selectedKeys]="selectedWorkOrders()" [rowSelected]="isRowSelected"
    (selectionChange)="selectionChange($event)" (filterChange)="onFilterChange($event)" filterable="menu"
    [resizable]="true" [reorderable]="true" (sortChange)="onSortChange($event)" (columnReorder)="onReorder($event)"
    (columnResize)="onGridColResize($event)" [trackBy]="trackGridByName" [loading]="loading()" kendoGridExpandGroupBy
    [groupsInitiallyExpanded]="false" [(expandedGroupKeys)]="expandedGroupKeys" [virtualColumns]="true">
    <kendo-grid-messages
      [filterContainsOperator]="'HOME_COMPONENTS.KENDO_GRID.CONTAINS' | translate"
      [filterNotContainsOperator]="'HOME_COMPONENTS.KENDO_GRID.DOES_NOT_CONTAIN' | translate"
      [filterEqOperator]="'HOME_COMPONENTS.KENDO_GRID.EQUALS' | translate"
      [filterNotEqOperator]="'HOME_COMPONENTS.KENDO_GRID.DOES_NOT_EQUAL' | translate"
      [filterIsNullOperator]="'HOME_COMPONENTS.KENDO_GRID.IS_NULL' | translate"
      [filterIsNotNullOperator]="'HOME_COMPONENTS.KENDO_GRID.IS_NOT_NULL' | translate"
      [filterStartsWithOperator]="'HOME_COMPONENTS.KENDO_GRID.BEGINS_WITH' | translate"
      [filterEndsWithOperator]="'HOME_COMPONENTS.KENDO_GRID.ENDS_WITH' | translate"
      [filterGteOperator]="'HOME_COMPONENTS.KENDO_GRID.GREATER_THAN_OR_EQUAL' | translate"
      [filterGtOperator]="'HOME_COMPONENTS.KENDO_GRID.GREATER_THAN' | translate"
      [filterLteOperator]="'HOME_COMPONENTS.KENDO_GRID.LESS_THAN_OR_EQUAL' | translate"
      [filterLtOperator]="'HOME_COMPONENTS.KENDO_GRID.LESS_THAN' | translate"
      [filterIsEmptyOperator]="'HOME_COMPONENTS.KENDO_GRID.BLANK' | translate"
      [filterIsNotEmptyOperator]="'HOME_COMPONENTS.KENDO_GRID.NOT_BLANK' | translate"
      [filterIsTrue]="'HOME_COMPONENTS.KENDO_GRID.IS_TRUE' | translate"
      [filterIsFalse]="'HOME_COMPONENTS.KENDO_GRID.IS_FALSE' | translate"
      [filterBooleanAll]="'HOME_COMPONENTS.KENDO_GRID.BOOLEAN_ALL' | translate"
      [filterAfterOrEqualOperator]="'HOME_COMPONENTS.KENDO_GRID.AFTER_OR_EQUAL_TO' | translate"
      [filterAfterOperator]="'HOME_COMPONENTS.KENDO_GRID.AFTER' | translate"
      [filterBeforeOperator]="'HOME_COMPONENTS.KENDO_GRID.BEFORE' | translate"
      [filterBeforeOrEqualOperator]="'HOME_COMPONENTS.KENDO_GRID.BEFORE_OR_EQUAL_TO' | translate"
      [filterFilterButton]="'HOME_COMPONENTS.KENDO_GRID.APPLY' | translate"
      [filterClearButton]="'HOME_COMPONENTS.KENDO_GRID.CLEAR' | translate"
      [filterAndLogic]="'HOME_COMPONENTS.KENDO_GRID.AND' | translate"
      [filterOrLogic]="'HOME_COMPONENTS.KENDO_GRID.OR' | translate"
      [filterDateToday]="'HOME_COMPONENTS.KENDO_GRID.TODAY' | translate"
      [filterDateToggle]="'HOME_COMPONENTS.KENDO_GRID.TOGGLE_CALENDAR' | translate">
    </kendo-grid-messages>
    <!--   Add this back to above grid when grouping is enabled [kendoGridGroupBinding]="groupGridData()" -->
    <ng-template kendoGridToolbarTemplate>
      <div class="grid-title-container">
        <div class="grid-title-button">
          <span>{{ 'HOME_COMPONENTS.KENDO_GRID.SHOW' | translate }}: </span>
          <kendo-chip class="kendo-chip-style me-1 small" [label]="'HOME_COMPONENTS.KENDO_GRID.ALL' | translate" [selected]="showItem() === 'All'"
            (contentClick)="onShowChange('All')">
          </kendo-chip>
          <kendo-chip class="kendo-chip-style me-1 small" [label]="'HOME_COMPONENTS.KENDO_GRID.SELECTED' | translate" [selected]="showItem() === 'Selected'"
            (contentClick)="onShowChange('Selected')">
          </kendo-chip>
          <kendo-chip class="kendo-chip-style me-1 small" [label]="'HOME_COMPONENTS.KENDO_GRID.UNSELECTED' | translate" [selected]="showItem() === 'UnSelected'"
            (contentClick)="onShowChange('UnSelected')">
          </kendo-chip>
        </div>
        <div class="d-flex align-items-center">
          <!-- PII Toggle Button -->
          <button
            kendoButton
            class="me-2"
            (click)="togglePii()"
            [title]="isPiiRevealed ? ('HOME_COMPONENTS.PII.HIDE' | translate) : ('HOME_COMPONENTS.PII.REVEAL' | translate)"
            fillMode="flat"
            size="small"
            >
            <fa-icon [icon]="isPiiRevealed ? faEye : faEyeSlash"></fa-icon>
          </button>

          <button kendoButton (click)="showConfirmation()" [svgIcon]="filterClearIcon" themeColor="primary"
            class="clear-filter" [title]="'HOME_COMPONENTS.KENDO_GRID.CLEAR_FILTERS' | translate"
          [disabled]="!(gridState()?.filter?.filters?.length > 0)"></button>


          <div class="grid-title-text">
            {{ gridData().total | number }}/{{ workOrders().length | number }}
            {{
            workOrders().length > 1
            ? ('HOME_COMPONENTS.KENDO_GRID.RECORDS' | translate)
            : ('HOME_COMPONENTS.KENDO_GRID.RECORD' | translate)
            }}
          </div>
        </div>
      </div>
    </ng-template>
    <kendo-grid-column [width]="100" [reorderable]="false" field="Index" title="#" [filterable]="false"
      [sortable]="false">
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        <div style="width: 20px" class="small-column">
          {{ (rowIndex + 1) | number }}
        </div>
      </ng-template>
    </kendo-grid-column>
    <kendo-grid-checkbox-column [reorderable]="false" [showSelectAll]="true" [width]="60">
      <ng-template kendoGridHeaderTemplate>
        <span class="pe-2">
          {{ selectedWorkOrders()?.length }}
        </span>
        <input #chkHeader class="k-checkbox k-checkbox-md k-rounded-md" id="chkHeader" type="checkbox"
          [indeterminate]="selectedWorkOrders()?.length > 0 && selectedWorkOrders().length < gridData()?.total"
          [checked]="selectedWorkOrders()?.length > 0 && selectedWorkOrders()?.length == gridData()?.total"
          (change)="onSelectAllChange()" />
      </ng-template>
      <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
        <div class="align-items-center justify-content-center d-flex">
          <input type="checkbox" kendoCheckBox [kendoGridSelectionCheckbox]="rowIndex" />
        </div>
      </ng-template>
    </kendo-grid-checkbox-column>
    <kendo-grid-command-column [reorderable]="false" class="small-text" [title]="'HOME_COMPONENTS.KENDO_GRID.DETAILS' | translate" [width]="100">
      <ng-template kendoGridCellTemplate let-dataItem let-column="column">
        <a class="cursorpointer" (click)="detailsPageNavigation(dataItem.name)">{{ 'HOME_COMPONENTS.KENDO_GRID.DETAILS' | translate }}</a>
      </ng-template>
    </kendo-grid-command-column>
    @for (col of localColumnList; track trackColumnsByField($index, col)) {
      <kendo-grid-column class="small-text"
        [field]="col.field" [title]="col.title" [width]="col.width ? col.width + extraWidth(): 152 + extraWidth()"
        [filter]="col.filter" [filterable]="col.filterable" [hidden]="col.hidden" [format]="col.format"
        [groupable]="col.field === 'WorkOrderId' || col.field === 'TaskId' || col.field === 'ServicePointId' ? false: true">
        @if (isPii(col)) {
          <ng-template kendoGridHeaderTemplate>
            <app-pii-mask-header class="d-block w-100" [title]="col.title" [groupKey]="col.field" [showToggle]="true"></app-pii-mask-header>
          </ng-template>
        }
        <ng-template kendoGridGroupHeaderTemplate let-value="value" let-aggregates="aggregates" let-field="field">
          <span style="text-decoration: underline">
            {{ col.title }}: {{ value }} ({{ aggregates["Index"]?.count }})
          </span>
        </ng-template>
        <!-- PII Masking Template -->
        @if (isPii(col); as dataItem) {
          <ng-template kendoGridCellTemplate let-dataItem>
            <app-pii-mask [value]="getCellValue(dataItem, col)" [group]="col.field"></app-pii-mask>
          </ng-template>
        }
        <ng-template *ngIf="col.field == wOBlackout.BlackoutRemainingDays" kendoGridCellTemplate let-dataItem
          let-rowIndex="rowIndex" let-columnIndex="columnIndex">
          <span class="whole-cell" [style.backgroundColor]="colorCodeforBG(dataItem)"
            [style.color]="getBlackoutTextColorCode(dataItem)">
            {{ dataItem | blackout:col.field }}
          </span>
        </ng-template>
      <ng-template *ngIf="
          col.field == genericEnumValueString.StatusWeb ||
          col.field == genericEnumValueString.PostProcessing
        " kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex" let-columnIndex="columnIndex">
          <span class="whole-cell" [style.backgroundColor]="colorCodeforBG(dataItem)"
            [style.color]="colorCodeforText(dataItem)">
            {{ getStatus(dataItem[col.field]) }}
          </span>
        </ng-template>
        @if (col.field == genericEnumValueString.StatusWeb; as filter) {
          <ng-template kendoGridFilterCellTemplate let-filter>
            <dropdown-filter [filter]="filterLocalInline" [data]="statusWebList" textField="text" valueField="value"
            [filterField]="col.field"></dropdown-filter>
          </ng-template>
        }
        <ng-template *ngIf="col.filter == 'date'" kendoGridFilterMenuTemplate let-filter let-column="column" let-filterService="filterService">
          <kendo-grid-date-filter-menu
            [column]="column"
            [filter]="filter"
            [filterService]="filterService"
          [formatPlaceholder]="{
            month: ('HOME_COMPONENTS.KENDO_GRID.MONTH' | translate),
            day: ('HOME_COMPONENTS.KENDO_GRID.DAY' | translate),
            year: ('HOME_COMPONENTS.KENDO_GRID.YEAR' | translate)
          }">
          </kendo-grid-date-filter-menu>
        </ng-template>
        <ng-template *ngIf="col.field == 'EventDate'" kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex"
          let-columnIndex="columnIndex">
          {{ dataItem.EventDateWithTime | timezonedate : timezone() | date:"MMM dd, yyyy 'at' hh:mm a" }}
        </ng-template>
        <ng-template *ngIf="col.field == 'CompletedOn'" kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex"
          let-columnIndex="columnIndex">
          {{ dataItem.CompletedOnWithTime | timezonedate : timezone() | date:"MMM dd, yyyy 'at' hh:mm a" }}
        </ng-template>
        <ng-template *ngIf="col.field == 'StartDateBlackout'" kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex"
          let-columnIndex="columnIndex">
          {{ dataItem.StartDateBlackout | date:"MM/dd/yyyy"  }}
        </ng-template>
        <ng-template *ngIf="col.field == 'EndDateBlackout'" kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex"
          let-columnIndex="columnIndex">
          {{ dataItem.EndDateBlackout | timezonedate : timezone() | date:"MM/dd/yyyy" }}
        </ng-template>
        <ng-template *ngIf="col.field == 'CompletedOn'" kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex"
          let-columnIndex="columnIndex">
          {{ dataItem.CompletedOnWithTime | timezonedate : timezone() | date:"MMM dd, yyyy 'at' hh:mm a" }}
        </ng-template>
        <ng-template *ngIf="col.field == 'AppointmentDate'" kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex"
          let-columnIndex="columnIndex">
          {{ dataItem.AppointmentDateWithTime | timezonedate : timezone() | date:"MMM dd, yyyy 'at' hh:mm a" }}
        </ng-template>
        <ng-template *ngIf="col.field == 'InstallDate'" kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex"
          let-columnIndex="columnIndex">
          {{ dataItem.InstallDate | date:"MM/dd/yyyy" }}
        </ng-template>
      </kendo-grid-column>
    }

    <kendo-contextmenu #gridmenu [target]="gridcontainer" [kendoMenuHierarchyBinding]="menuItems"
      [textField]="['text', 'childText']" childrenField="children" svgIconField="svgIcon" separatorField="separator"
    (select)="onSelectMenu($event)"></kendo-contextmenu>
  </kendo-grid>

  @if (loading() === true) {
    <div class="k-loading-image"></div>
  }

  @if (isColumnOption) {
    <div class="backdrop"></div>
  }
</div>


@if (showConfirmationDialog) {
  <kendo-dialog [title]="'HOME_COMPONENTS.COMMON.PLEASE_CONFIRM' | translate" (close)="confirm(false)" [minWidth]="250"
    [width]="450">
    <p style="margin: 30px; text-align: center;">
      {{ 'HOME_COMPONENTS.KENDO_GRID.CLEAR_FILTERS_CONFIRM' | translate }}
    </p>
    <kendo-dialog-actions [layout]="'end'">
      <button kendoButton (click)="confirm(false)">{{ 'HOME_COMPONENTS.COMMON.NO' | translate }}</button>
      <button kendoButton (click)="confirm(true)" themeColor="primary">
        {{ 'HOME_COMPONENTS.COMMON.YES' | translate }}
      </button>
    </kendo-dialog-actions>
  </kendo-dialog>
}
